"use client";
import { UpgradeSuccessContent } from "./UpgradeSuccessContent";
import type { UpgradeSuccessContentProps } from "./types";
import { EdgenModalCreateAble } from "@components/EdgenModal";

export interface UpgradeSuccessModalCreateAbleProps extends UpgradeSuccessContentProps {
  /** 关闭时的回调（如跳转、刷新等） */
  onClose?: () => void;
}

/**
 * 以 EdgenDrawer 形式弹出升级成功内容，复用全局 EdgenDrawerCallable.Root
 * @returns Promise<boolean> 用户点击「Get started」并关闭为 true，其余关闭为 false
 */
export const UpgradeSuccessModalCreateAble = async (
  props: UpgradeSuccessModalCreateAbleProps,
): Promise<boolean> => {
  const { onClose, ...contentProps } = props;

  const handleClose = () => {
    onClose?.();
    EdgenModalCreateAble.end(false);
  };

  /** 用户点击「Get started」：先执行业务回调，再 end(false) 关闭 */
  const handleGetStarted = () => {
    props.onSuccessFunction?.();
    EdgenModalCreateAble.end(false);
  };
  return EdgenModalCreateAble.call({
    destroyOnClose: true,
    containerClassName:
      "!md:w-[400px] !md:rounded-[16px] max-md:!w-[calc(100vw-32px)]",
    contentStyle: {
      backgroundColor: "#1A1A1A",
      padding: 0,
      borderRadius: "16px",
    },
    titleStyle: {
      minHeight: 0,
    },
    showClose: false,
    centered: true,
    children: (
      <UpgradeSuccessContent
        {...contentProps}
        onSuccessFunction={handleGetStarted}
        onClose={handleClose}
      />
    ),
  });
};
